var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "charts" }, [
      _c("div", { ref: "barChart", staticClass: "chart" }),
      _c("div", { ref: "pieChart", staticClass: "chart" }),
      _c("div", { ref: "lineChart", staticClass: "chart" })
    ]),
    _c(
      "div",
      { staticClass: "table-container" },
      [
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
          [
            _c("el-table-column", {
              attrs: { prop: "park", label: "园区", width: "180" }
            }),
            _c("el-table-column", {
              attrs: { prop: "hardware", label: "硬件故障", width: "180" }
            }),
            _c("el-table-column", {
              attrs: { prop: "software", label: "软件问题", width: "180" }
            }),
            _c("el-table-column", {
              attrs: { prop: "network", label: "网络问题", width: "180" }
            }),
            _c("el-table-column", {
              attrs: { prop: "other", label: "其他", width: "180" }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }